import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { Logo } from "@/components/Logo";
import { useDialogs } from "@/components/GlobalDialogs";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/events", label: "Classes & Sessions" },
  { to: "/learn-earn", label: "Learn & Earn" },
  { to: "/studio", label: "YTCA Studio" },
  { to: "/blog", label: "Blog" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { openJoin } = useDialogs();
  useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-md">
      <div className="ytca-container flex h-16 items-center justify-between gap-4">
        <Logo />

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className={({ isActive }) =>
                `rounded-full px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-secondary text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            onClick={openJoin}
            data-testid="header-join-ytca-button"
            className="hidden rounded-full sm:inline-flex"
          >
            Join YTCA
          </Button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="outline" size="icon" className="rounded-full md:hidden" data-testid="mobile-menu-button">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[280px] bg-background">
              <div className="mt-6 flex flex-col gap-1">
                {NAV.map((item) => (
                  <SheetClose asChild key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.to === "/"}
                      data-testid={`mobile-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                      className={({ isActive }) =>
                        `rounded-lg px-3 py-3 text-base font-medium ${
                          isActive ? "bg-secondary text-foreground" : "text-muted-foreground"
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  </SheetClose>
                ))}
                <Button
                  onClick={() => {
                    setOpen(false);
                    openJoin();
                  }}
                  data-testid="mobile-join-ytca-button"
                  className="mt-4 rounded-full"
                >
                  Join YTCA
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
